export const PERMS = {
    READ: 'vehicle_documents.read',
    UPDATE: 'vehicle_documents.update',
    DELETE: 'vehicle_documents.delete',
    CREATE: 'vehicle_documents.create',
    EXPORT: 'vehicle_documents.export',
}
